import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { SxProps, Theme } from "@mui/material/styles";

const PAGE_SX: SxProps<Theme> = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.default",
};

const HEADER_SX: SxProps<Theme> = {
  py: "2.5rem",
  display: "flex",
  justifyContent: "center",
};

const PANEL_SX: SxProps<Theme> = (theme: Theme) => ({
  flex: 1,
  bgcolor: "background.paper",
  borderTopLeftRadius: Number(theme.shape.borderRadius) * 2,
  borderTopRightRadius: Number(theme.shape.borderRadius) * 2,
  px: "1.5rem",
  pt: "2.5rem",
});

const CONTENT_SX: SxProps<Theme> = {
  maxWidth: "28rem",
  mx: "auto",
  width: "100%",
};

// Shown in place of the real page while the Strapi login-page styling is
// still loading, so the layout doesn't pop in unstyled/blank.
const LayoutSkeleton = (): JSX.Element => (
  <Box sx={PAGE_SX}>
    <Box sx={HEADER_SX}>
      <Skeleton variant="rounded" width={120} height={40} />
    </Box>
    <Box sx={PANEL_SX}>
      <Box sx={CONTENT_SX}>
        <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={56} sx={(theme) => ({ mb: 2, borderRadius: `${theme.shape.borderRadius}px` })} />
        <Skeleton variant="rounded" height={56} sx={(theme) => ({ mb: 3, borderRadius: `${theme.shape.borderRadius}px` })} />
        <Skeleton variant="rounded" height={56} sx={(theme) => ({ borderRadius: `${theme.shape.borderRadius}px` })} />
      </Box>
    </Box>
  </Box>
);

export default LayoutSkeleton;
